import axios from 'axios'
import { host } from '../../helper/config'
import { getItemPerPage } from '../../helper/helper'

const PLUGINS_NAME = 'admin-sepay-transaction'

export const getSepayTransactionList = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list`, {
        ...query,
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}
